import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDockToLeftWithBadge = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("mask", {
		id: "mask0_4879_12946",
		style: { maskType: "alpha" },
		maskUnits: "userSpaceOnUse",
		x: 0,
		y: 0,
		width: 24,
		height: 24,
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			fill: "#D9D9D9"
		})
	}), /* @__PURE__ */ _jsxs("g", {
		mask: "url(#mask0_4879_12946)",
		children: [/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M21 10.4003V19.5C21 19.9125 20.8532 20.2656 20.5595 20.5592C20.2657 20.8531 19.9125 21 19.5 21H4.5C4.0875 21 3.73442 20.8531 3.44075 20.5592C3.14692 20.2656 3 19.9125 3 19.5V4.5C3 4.0875 3.14692 3.73433 3.44075 3.4405C3.73442 3.14683 4.0875 3 4.5 3H13.5997C13.3617 3.46553 13.1881 3.96945 13.0907 4.5H4.5V19.5H14.325V9.08057C14.7472 9.57245 15.2549 9.98886 15.825 10.3068V19.5H19.5V10.9093C20.0306 10.8119 20.5345 10.6383 21 10.4003Z",
			fill: "#60646C"
		}), /* @__PURE__ */ _jsx("circle", {
			cx: 18.5,
			cy: 5.5,
			r: 3.5,
			fill: "#E5484D"
		})]
	})]
});
export default SvgDockToLeftWithBadge;
